<template>
  <div
    v-if="showNotice"
    class="toasts"
  >
    <ul class="list-unstyled c-mb-0">
      <transition-group name="fade">
        <li
          class="c-mt-2 c-p-2 text-white c-rounded-lg shadow"
          :class="getNoticeBackground"
        >
          <div class="row no-gutters">
            <!-- image or icon -->
            <div class="col-3 c-pr-2">
              <i class="mi-cart icon-32" />
            </div>
            <!-- text -->
            <div
              class="col c-self-center text-sm-c font-bold"
              v-html="getNoticeText"
            />
            <!-- close button -->
            <div class="col-auto">
              <button
                type="button"
                class="btn c-p-1 c-rounded-pill"
                @click="noticeStore.removeNotice()"
              >
                <i class="mi-times icon-20" />
              </button>
            </div>
          </div>
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'

import { useNoticeStore } from '@/stores/NoticeStore'

const noticeStore = useNoticeStore()

const { showNotice, getNoticeText, getNoticeBackground } = storeToRefs(noticeStore)
</script>

<style lang="scss">
.toasts{
	position: fixed;
	z-index: $zindex-sticky;

	bottom: map-get($spacers, 2);
	right: map-get($spacers, 2);

	width: 260px;

	a, button{
		color: inherit;

		&:hover{
			color: rgba($dark, 0.6);
		}
	}

	@include media-breakpoint-up(c-md){
		bottom: map-get($spacers, 4);
		right: map-get($spacers, 4);
	}
}
</style>
